/**
 * The Admin area's section links (Phase 7b): users, groups, sites and nodes,
 * device secrets, the audit log, usage and cost. Real `href`s, so a section
 * opens in a new tab; a plain click is an event (`onNavigate`). The container
 * decides which sections the caller may see (`tenant.admin`, `billing.view`).
 */
import { isPlainClick } from '../../lib/links.js';
import { cn } from '../../lib/utils.js';

export type AdminSection = { readonly label: string; readonly href: string; readonly active: boolean };

export type AdminNavProps = {
  readonly sections: readonly AdminSection[];
  readonly onNavigate: (href: string) => void;
};

export function AdminNav({ sections, onNavigate }: AdminNavProps) {
  return (
    <nav aria-label="Admin" className="flex flex-wrap gap-1 border-b pb-2" data-testid="admin-nav">
      {sections.map((section) => (
        <a
          key={section.href}
          href={section.href}
          aria-current={section.active ? 'page' : undefined}
          className={cn('rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground', section.active && 'bg-secondary text-secondary-foreground')}
          onClick={(event) => {
            if (!isPlainClick(event)) return;
            event.preventDefault();
            onNavigate(section.href);
          }}
        >
          {section.label}
        </a>
      ))}
    </nav>
  );
}
